import { useTheme } from '@mui/material/styles';
import { line, scaleLinear } from 'd3';
import { memo } from 'react';

const tickLineLong = line()
	.x(0)
	.y((d, i) => i)({ length: 35 });

const tickLineShort = line()
	.x(0)
	.y((d, i) => i)({ length: 15 });
const getTickRef = ({tickCount, minVal, maxVal, minAngle, maxAngle, labelTickCount, decimals}) => {
	if (tickCount % 2 === 0) console.warn('Ticks should be odd numbered to ensure a tick in in the middle of the gauge.');

	const idxToRef = scaleLinear()
		.domain([0, tickCount - 1])
		.range([0, 1]);

	const idxToVal = scaleLinear()
		.domain([0, tickCount - 1])
		.range([minVal, maxVal]);

	const refToDeg = scaleLinear().domain([0, 1]).range([minAngle, maxAngle]);

	return [...Array(tickCount)].map((v, i) => {
		let val = parseFloat(Number(idxToVal(i)).toFixed(decimals));
		
		const isTextTick = i === 0 || i === tickCount - 1 || i % labelTickCount === 0;
		return {
			index: i,
			val,
			d: isTextTick ? tickLineLong : tickLineShort,
			deg: refToDeg(idxToRef(i)),
			text: isTextTick ? val : undefined,
			showText: isTextTick,
			isTextTick
		};
});
};



const Label = ({
	disabled,
	center,
	tickCount,
	min,
	max,
	maxAngle,
	minAngle,
	offsetText,
	length = 300 / 2 - 30,
	labelTickCount = 1,
	fill,
	tickLabelDecimals = 0
}) => {
	const ticks = getTickRef({
		tickCount,
		minVal: min,
		maxVal: max,
		minAngle,
		maxAngle,
		labelTickCount,
		decimals: tickLabelDecimals
	});
	const theme = useTheme();

	return ticks.map(({ val, deg, isTextTick, text, d, showText }) => (
		<g
			className="gauge-label"
			style={{ userSelect: 'none', textAlign: 'center' }}
			key={val}
			transform={`translate(${center.x},${center.y}) rotate(${deg})`}
		>
			<path
				d={d}
				stroke={fill || theme.palette.text.primary || '#344c69'}
				strokeWidth="1"
				transform={`translate(0,${isTextTick ? 7.5 - length : 15.5 - length})`}
				style={{ transition: 'all .25s .25s' }}
				opacity={disabled ? 0.4 : undefined}
			/>
			{showText && (
				<text
					transform={`translate(${offsetText},${-length})`}
					style={{ transition: 'all .25s .25s', fontSize: '85%' }}
					opacity={disabled ? 0.4 : undefined}
				>
					{text}
				</text>
			)}
		</g>
	));
};

export default memo(Label);
